import type { CSSProperties } from 'react';

import type { DomainKey } from '@shared/components/ui';

/**
 * Props that give a nav row a faint domain-colored hover wash (paired with the
 * `.nav-row-domain` rule in index.css). Returns an empty className for non-domain
 * rows so they keep the neutral hover.
 */
export function domainHoverProps(domain?: DomainKey): {
  className: string;
  style?: CSSProperties;
} {
  if (!domain) return { className: '' };
  return {
    className: 'nav-row-domain',
    style: { '--domain-tint': `var(--domain-${domain})` } as CSSProperties,
  };
}
